<template>
<ur-modal ref="detailModal" large>
  <div class="modal_header" style="text-align:center">
    <p class="modal_title">{{this.title}}</p>
    <!-- <p class="modal_sub_title">개인정보처리방침</p> --><!-- 뭘 넣을지 기획에 확인 필요 -->
  </div>
  <div class="modal_body terms" style="overflow:auto">
    <div class="terms_content" v-html="content">
    </div>
  </div>
  <div class="modal_footer">
    <ur-button size="large" @click="closeModalPopup(false)">비 동의</ur-button>
    <ur-button solid primary size="large" @click="closeModalPopup(true)">동의</ur-button>
  </div>
</ur-modal>
</template>

<script>

import BasePage from '~cm/components/BasePage';

export default {
  name: "PGE_AIM_00005_P01",
  extends: BasePage,

  components: {
    BasePage,
  },

  props: {
    pageId: {
      type: String, 
      required: true,
    },
    closeDetailPopup: {
      type: Function,
      default: () => {},
    },
    pageInitialData: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      title: '',
      content: '',
    };
  },

  created() {      
  },

  computed: {

  },
  
  watch: {      
  },

  mounted() {
  },
  
  methods: {
    open(){
      // console.log('value', value);
      this.init();
      this.$refs['detailModal'].open();
    },
    close(){
      this.$refs['detailModal'].close();
    },

    init() {
      console.log(JSON.stringify(this.pageInitialData))
      this.parentPageId = this.pageInitialData.parentPageId;
      this.title = this.pageInitialData.termsName;
      this.content  = this.pageInitialData.termsContent;
    },

    closeModalPopup(check) {
      this.pageInitialData.isChecked = check;
      this.$emit('closeDetailPopup');
      // this.close();
    },
  }
    

};
</script>

<style scoped>
/* ========== modal ========== */
.modal {position: fixed; top: 0; left: 0; right: 0; bottom: 0;z-index: 32 }
.modal:before {display: block; content:''; width:100%; height: 100%; background-color: rgba(0, 0, 0, 0.3);}
.modal_dialog { display:-webkit-box; display:-ms-flexbox;display:flex;-webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center; position: absolute; top: 0; width: 100%; height: 100%;}
.modal_content {width:704px; min-height:218px; background-color: #fff; border-radius: 8px; box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1); border: solid 1px #d0d3de; padding: 32px;}
.modal_header {margin-bottom:24px; position: relative;}
.modal_header .modal_title {font-size:24px; line-height: 32px; font-weight: 700;}
.modal_header .modal_title + p {color:#767676; font-size: 14px; margin-top:8px;}
/* .modal_header .close {display:inline-block; width:20px; height: 20px; background: url(../../images/aicc/btn_close_20.png) no-repeat 50% 50%; position: absolute; top: 0; right: 0; font-size: 0; line-height: 0;} */
.modal_body {font-size:14px; line-height: 24px; min-height: 48px; min-height: 80px; overflow: auto;}
.alert .modal_body {min-height: 48px;}
.modal_footer {font-size: 0;margin-top:32px; text-align: right; }
.modal_footer .btn + .btn {margin-left: 8px}
.modal_footer .btn_temp:after {display:inline-block; content:''; width: 1px; height: 24px; background-color:#ccc; position: absolute; top:3px; right: -11px;}
.modal_footer .btn_temp {position: relative; margin-right: 20px !important;}
.modal_footer .btn_temp + .btn {margin-left: 0}
.modal_footer .btn_temp ~ .btn:disabled {position: relative;  border: 0; background-color: #f7f7f7; color:#a5a5a5}

.modal_content.modal_sm {width:464px;}
.modal_content.modal_sm .modal_header {margin-bottom:16px;}
.modal_content.modal_sm .modal_body {padding-right:0}
.modal_content.modal_sm .modal_footer {margin-top: 24px;}
.modal_content.modal_sm .data_tbl_list th {padding: 10px 0 11px 16px}

.modal_content.modal_lg {width:944px;padding: 48px 48px 32px;}
.modal_content.modal_lg .modal_header {margin-bottom:32px}
.modal_content.modal_lg .modal_header .close {right: -16px}
.modal_content.modal_lg .modal_footer {margin-top:48px}

.dimmed{position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; z-index: 99; opacity: 0.5; background-color: rgb(0, 0, 0);}
</style>
